export default {
  // ========== Titles and labels ==========
  versions: 'Versions',
  changeState: 'Change the state of',
  modificationDate: 'Modification date',
  user: 'User',
  comment: 'Comment',
  applied: 'Applied',
  view: 'View',
  seeModification: 'See modification',
  applyModification: 'Apply modification',
  deleteModification: 'Delete modification',
  saveComment: 'Save comment',
  loading: 'Loading...',

  // ========== Copy modal ==========
  shouldNotExceedDuration: 'should NOT exceed the duration of',
  selectElementsNotToCopy: 'Select the elements you do <strong>NOT</strong> want to copy',
  copyModalInfoTitle: 'A copy of the selected {entity} will be created.',
  copyModalInfoDescription: 'By default, <strong>all</strong> elements will be copied. If you wish to <strong>exclude</strong> any, select them in the table and press the remove button.',
  copyModalStep1: 'Review the elements to copy',
  copyModalStep2: 'Exclude unwanted items (optional)',
  copyModalStep3: 'Confirm the copy',
  copyModalSummaryIncluded: '{count} will be copied',
  copyModalSummaryExcluded: '{count} excluded',
  copyModalNoElements: 'This {entity} has no associated {matters} or {wrappers}. Only the base profile information will be copied.',
  copyModalWrapperSection: 'Wrappers to copy',
  copyModalMatterSection: 'Subjects to copy',

  // ========== Table fields ==========
  creation: 'Creation',
  duration: 'Duration',
  vigencyYear: 'Effective Year',
  type: 'Type',

  // ========== Success messages ==========
  commentSaved: 'Comment saved.',
  modificationUpdated: 'Modification updated!',
  modificationDeleted: 'Modification deleted!',

  // ========== Confirmation messages ==========
  sureToApplyModification: 'Are you sure you want to apply this modification?',
  sureToDeleteModification: 'Are you sure you want to delete this modification?',
  thisChangeIsIrreversible: 'This change is irreversible.',

  // ========== Success messages with context ==========
  requestSuccessful: 'The request was successful.',

  // ========== Error messages ==========
  errorOccurredRequest: 'An error occurred while making the request',

  // ========== History texts ==========
  revertedToModification: 'Reverted to the previous modification, saved on:',

  // ========== EgressProfile Form ==========
  previous: 'previous',
  intermediateOutputCode: 'Intermediate output code',
  intermediateOutputName: 'Intermediate output name',
  continuityCode: 'Continuity code',
  continuityName: 'Continuity name',
  modality: 'Modality',
  admissionType: 'Admission type',
  initDate: 'Start date',
  defineInitDate: 'Define start date',
  intermediateOutputSemester: 'Intermediate output semester',
  campusesDescription: 'Showing the {campuses} of the {faculty}.',
  selectOneOrMultiple: 'Select one or multiple {entity}',
  noResults: 'No results found for',

  // ========== Validations ==========
  mustSelect: 'You must select a {entity}.',
  codeAlreadyUsed: 'The code is already being used.',
  cannotExceedDuration: 'Cannot exceed the duration.',
  durationRange: 'This field must be greater than or equal to 1 and less than or equal to 40',
  enterValidYear: 'Enter a valid year',
  mustEnterValidInitDate: 'You must enter a valid start date.',
  mustSelectProfileType: 'You must select a profile type.',
  mustSelectAdmissionType: 'You must select an admission type.',

  // ========== Modal confirmation messages ==========
  whenCanceling: 'When canceling, the duration of the {entity} will return to its original state.',
  applyChanges: 'Apply changes',
  durationOf: 'Duration of',

  // ========== RemoveEPMattersComponent ==========
  selected: 'Selected',
  selectedToNotBeCopied: 'selected not to be copied:',
  remove: 'Remove',
  reassignLevel: 'Reassign level',
  to: 'to',
  listOf: 'List of',
  toDelete: 'to delete',
  thatWillNotBeCopied: 'that will not be copied:',
  integrate: 'Integrate',
  reintegrateAll: 'Reintegrate all',
  fromTheCopy: 'from the copy',
  select: 'Select',
  exclude: 'Exclude',
  planLevel: 'Plan level',
  planLevelExceedsProfile: 'The plan level of the {matter} exceeds that of the {profile}',
  wantToRemoveSelected: 'Do you want to remove the selected {entities}?',
  actionWillUnlinkObjects: 'This action cannot be undone and will unlink the selected objects from this {entity}.',

  // ========== CoursesWrapperView ==========
  goTo: 'Go to',
  of: 'of',
  initialLevel: 'Initial level',
  finalLevel: 'Final level',
  totalPedagogicalHours: 'Total pedagogical hours',
  initialLevelMustNotExceed: 'The initial level must not exceed that of the {entity}.',
  initialLevelMustNotBeSuperiorToFinal: 'Initial level must not be higher than final level',
  deletedFeminine: 'deleted.',
  ni: 'IL',
  nf: 'FL',

  // ========== CareerForm ==========
  selectOne: 'Select a',
  selectA: 'Select a',
  noCreated: 'No',
  created: 'created.',
  preview: 'Preview',
  selectToPreview: 'to preview.',
  noResultsFor: 'No results found for:',
  genericCareer: 'Generic career',

  // ========== CoursesWrapperForm ==========
  mustBeGreaterThanZeroAndLessOrEqual: 'This field must be greater than 0 and less than or equal to',
  finalLevelMustNotBeLowerThanInitial: 'Final level must not be lower than initial level',
  cannotBeEmpty: 'This field cannot be empty.',
  goToCurricularDefinitionsToCreate: 'Go to Curricular Definitions to create',
  credit: 'Credit',
  automatic: 'Automatic',
  planned: 'Planned',
  thisDoesNotHave: 'This {entity} does not have',

  // ========== FormationLineForm ==========
  createdSuccessfully: 'Created successfully:',
}
